export enum BOOK_INVITE_FIELD_KEY {
    recipientName = 'recipientName',
    inviteMessage = 'inviteMessage',
}
